import { format } from 'date-fns';
import { DEFAULT_CURRENCY, COUNTRY_CODES } from '~/config/constants';

const defaultState = {
  ratesProvider: '',
  baseCurrency: '',
  rates: {},
  currentList: {},
};

const mutations = {
  setCurrent: (state, action) => {
    const dataForDate = state.rates[action.payload.meta.toDate];
    const selectedCurencyRate = dataForDate.rates.find(
      rate => rate.currency === action.payload.meta.currency,
    );

    if (selectedCurencyRate) {
      state.currentList = {
        baseCurrency: state.baseCurrency,
        provider: state.ratesProvider,
        date: dataForDate.date,
        dateFormated: format(
          new Date(dataForDate.date),
          action.payload.meta.dateMask,
          action.payload.meta.dateMask,
        ),
        amount: selectedCurencyRate.amount,
        currency: selectedCurencyRate.currency,
        rate: selectedCurencyRate.rate,
      };
    }
  },

  currencyRatesReceived: (state, action) => {
    const {
      rates, date, bank, base_currency: baseCurrency,
    } = action.payload.data;

    state.baseCurrency = baseCurrency;
    state.ratesProvider = bank;

    state.rates = {
      ...state.rates,
      [action.payload.meta.toDate]: {
        rates,
        date,
      },
    };
  },
  currencyRatesError: () => {
    // TODO - solve error handling: FO-911
  },
};

const actions = {
  setCurrencyRate({
    commit, state, rootState, rootGetters,
  }, { currency }) {
    if (currency === DEFAULT_CURRENCY || COUNTRY_CODES[rootGetters['env/country'].toUpperCase()] !== COUNTRY_CODES.CS) {
      return;
    }

    const toDate = rootState.invoiceForm.tax_point_on;
    const formatedDate = format(new Date(toDate), 'yyyy-M-d');

    if (state.rates.length === 0 || !state.rates[formatedDate]) {
      commit(
        'api/fetch',
        {
          url: `/services/exchange-rates/${formatedDate}`,
          method: 'GET',
          headers: {
            ...rootGetters['auth/getHeaders'],
          },
          onSuccess: [
            'currencyRates/currencyRatesReceived',
            'currencyRates/setCurrent',
          ],
          onError: ['currencyRates/currencyRatesError'],
          dateMask: rootState.env.dateFormats.dateFns,
          toDate: formatedDate,
          currency,
        },
        {
          root: true,
        },
      );
    } else {
      commit('setCurrent', {
        payload: {
          meta: {
            dateMask: rootState.env.dateFormats.dateFns,
            toDate: formatedDate,
            currency,
          },
        },
      });
    }
  },
  currencyRatesReceived({ commit }, payload) {
    commit('currencyRatesReceived', payload);
  },
  setCurrent({ commit }, payload) {
    commit('setCurrent', payload);
  },
  currencyRatesError({ commit }, payload) {
    commit('currencyRatesError', payload);
  },
};

const getters = {
  rates: state => state.rates,
  getCurrentList: state => state.currentList,
  getCurrency: state => currency => (
    state.rates.find(rate => rate.currency.toLowerCase() === currency)
  ),
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
